var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneralIconsNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 17.5,
    viewBox: "0 0 17.5 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.188-5H17.5V-15.312a.935.935,0,0,0-.937-.937H.938A.935.935,0,0,0,0-15.312V.313a.935.935,0,0,0,.938.938H11.25V-4.062A.94.94,0,0,1,12.188-5Zm5.039,2.148a.934.934,0,0,0,.273-.66V-3.75h-5v5h.234A.937.937,0,0,0,13.4.977Z",
    transform: "translate(0 16.25)",
    fill: "#3a3630",
    opacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralIconsNotes);
export default __webpack_public_path__ + "static/media/generalIcons_Notes.a7ab7993.svg";
export { ForwardRef as ReactComponent };